import cx from 'clsx';
import React, { memo } from 'react';

import { HeaderSlotProps } from '@/components/Header/HeaderSlot';
import styles from '@/components/Header/HeaderSlot.module.scss';
import { HeaderItem } from '@/components/Header/types';
import { isEqual } from '@/utils/lodash-alternatives';

import { createRel } from './utils';

interface InternalItemProps {
  item: HeaderItem;
  onInternalItemClick: HeaderSlotProps['onItemClick'];
}

const InternalItem: React.FC<InternalItemProps> = memo(
  ({ item, onInternalItemClick }) => {
    const { title, route_link } = item;
    const handleInternalItemClick = (
      e: React.MouseEvent<HTMLAnchorElement>
    ) => {
      e.preventDefault();
      onInternalItemClick({ title, route_link });
    };

    return (
      <a
        className={cx(
          styles.title,
          item.state === 'active' && styles.titleActive
        )}
        data-testid="slot-anchor-title"
        target={item.target || '_self'}
        rel={createRel(item)}
        href={route_link || ''}
        onClick={handleInternalItemClick}
      >
        {title}
      </a>
    );
  },
  (prevProps: InternalItemProps, nextProps: InternalItemProps) =>
    isEqual(prevProps, nextProps)
);

export default InternalItem;
